import PropTypes from 'prop-types';
import React from 'react';
import mapboxgl from 'mapbox-gl';

import DetailBlock from './DetailBlock';
import Mapbox from './Mapbox';

/**
 * DetailMap
 *
 * Renders a Mapbox Map of a given location
 *
 * @prop {Object}                  location - The location object with lat & lng properties
 * @prop {Number}                  location.lat
 * @prop {Number}                  location.lng
 * @prop {Integer}                 [defaultZoom=13] - The zoom level of the map
 * @prop {Number[][]|Number[][][]} [neighborhoodGeometry] - Polygon or MultiPolygon lat/lng paths
 * @prop {Boolean}  detailBlock    option to use detailBlock
 */

export default class DetailMap extends React.Component {
    constructor() {
        super();

        // Ensure system is actually capable of rendering WebGl
        this._isSupported = mapboxgl.supported();
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        if (!this._isSupported) {
            return null;
        }

        const {
            location,
            neighborhoodGeometry,
            mapboxAccessToken,
            detailBlock,
            showCircle,
            zoom,
            showMarker,
            enableNeighborhoodGeometry,
        } = this.props;
        const coords = [location.lng, location.lat];

        const hasNeighborhoodPaths =
            neighborhoodGeometry && !!neighborhoodGeometry.length && enableNeighborhoodGeometry;

        const map = (
            <Mapbox
                zoom={zoom}
                center={coords}
                neighborhoodGeometry={[neighborhoodGeometry]}
                hasNeighborhoodPaths={hasNeighborhoodPaths}
                showCircle={showCircle}
                token={mapboxAccessToken}
                showMarker={showMarker}
            />
        );

        if (!detailBlock) return map;

        return <DetailBlock noPadding>{map}</DetailBlock>;
    }
}

DetailMap.defaultProps = {
    zoom: 13,
    neighborhoodGeometry: [],
    detailBlock: true,
    showMarker: true,
    enableNeighborhoodGeometry: true,
};

DetailMap.propTypes = {
    location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }).isRequired,
    showCircle: PropTypes.bool,
    enableNeighborhoodGeometry: PropTypes.bool,
    zoom: PropTypes.number,
    showMarker: PropTypes.bool,
    neighborhoodGeometry: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
        PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))),
    ]),
    mapboxAccessToken: PropTypes.string,
    detailBlock: PropTypes.bool,
};
